module.exports = __webpack_public_path__ + "static/media/rsmQuestionThingy.be536ae5.svg";